import { gql } from "apollo-boost";

export const START_IDENTITY_VERIFICATION_PROCESS = gql`
  mutation startIdentityVerification($customerId: ID!, $flow: String!) {
    startIdentityVerification(customerId: $customerId, flow: $flow) {
      workflowRunId
      sdkToken
      smartCaptureUrl
      applicantId
    }
  }
`;
